import { Injectable } from '@angular/core';
import { getUpdatedDuration } from '@app/user-content/user-input-v2/utils/duration-helper';
import {
  getDSSkillsAdded,
  getDSSkillsRemoved,
} from '@app/user-content/user-input-v2/utils/inferred-skills-helper';
import { TrackerService } from '@dg/shared-services';
import { APIParameterModel, ViewModel } from './event.model';

@Injectable({ providedIn: 'root' })
export class EventTrackerService {
  protected inputType = 'Event';

  constructor(private tracker: TrackerService) {}

  public trackContentCatalogAdd(vm: ViewModel, api: APIParameterModel) {
    const {
      durationHours,
      durationMinutes,
      inputId,
      inputType,
      externalId,
      imageUrl,
      name,
      tags,
    } = api;

    const { mediumConfidenceInferredSkills, highConfidenceInferredSkills } = vm;

    const params = {
      action: 'Content Added to Catalog',
      properties: {
        contentId: inputId,
        contentType: inputType,
        dateModified: Date(),
        suggestedDuration: 'None',
        externalId: externalId,
        imageUrl: imageUrl,
        title: name,
        skillsAdded: getDSSkillsAdded(tags, mediumConfidenceInferredSkills),
        skillsRemoved: getDSSkillsRemoved(tags, highConfidenceInferredSkills),
        tagsCount: tags.length,
        updatedDuration: getUpdatedDuration(durationHours, durationMinutes),
      },
    };

    this.tracker.trackEventData(params);
  }

  public trackContentCatalogUpdate(api: APIParameterModel) {
    const params = {
      action: 'CMS Item Updated',
      location: 'Manage Org Catalog',
      category: this.inputType,
      properties: {
        ...api,
        suggestedDuration: 'None',
      },
    };

    this.tracker.trackEventData(params);
  }
}
